import React from 'react'
import { Experience } from '../../api/experiences/model'
import { ExperienceCardContent } from './ExperienceCardContent'
import { useBanquetProps } from 'banquet-runtime-modules'

type FullExperienceCardProps = {
  experience: Experience
}

export const FullExperienceCard = ({ experience }: FullExperienceCardProps) => {
  const { featureFlags } = useBanquetProps()

  const hasExperienceImagesFlag = Boolean(
    featureFlags?.['nv1-experience-images']
  )

  const hasExperienceImages =
    hasExperienceImagesFlag && experience.imageConfig?.mobileImageLocation

  return (
    <div className='flex flex-col xxs:flex-row justify-between gap-4 sm:gap-6 p-4 sm:p-6'>
      {hasExperienceImages ? (
        <img
          src={experience.imageConfig?.mobileImageLocation}
          alt=''
          className='h-full xxs:max-w-60 rounded-lg'
        />
      ) : null}
      <ExperienceCardContent experience={experience} />
    </div>
  )
}
